import styled from "styled-components";
import { colors, screenSizes, typography } from "@streeteasy/design-system";
import Tooltip from "@streeteasy/design-system/legacy/Tooltip";

export const Wrapper = styled.div`
  align-items: center;
  background: ${colors.NOTICE_LIGHTEST};
  justify-content: center;
  margin: 17px 0 0 -15px;
  padding: 7px 0;
  text-align: center;
  width: calc(100% + 15px);

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    padding: 6px 0;
  }
`;

export const Text = styled(typography.Caption)`
  color: ${colors.TEXT_PRIMARY};
  display: inline-block;
  margin-right: 5px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    margin-right: 20px;
  }
`;

export const TooltipContent = styled.div``;

export const StyledTooltip = styled(Tooltip)`
  [class*="styled__TooltipContent"] {
    min-width: 136px;
    @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
      right: calc(100% + 18px);
    }
  }

  [class*="styled__TooltipTriangle"] {
    bottom: 100%;

    @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
      bottom: auto;
    }
  }

  span {
    &::before {
      color: white;
      font-size: 37px;
    }
  }
`;

export const StyledTooltipIcon = styled.i.attrs(() => ({
  className: "fa fa-info-circle"
}))`
  color: ${colors.TEXT_SECONDARY};
  font-size: 13px;
`;
